var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.label))]),_c('v-radio-group',{attrs:{"row":"","mandatory":""},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}},[_c('v-radio',{attrs:{"label":"Sí","value":"Sí"}}),_c('v-radio',{attrs:{"label":"No","value":"No"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }